<template>
  <div
    class="status-hero rounded bg-lighten-5 d-flex align-items-center w-100"
    :class="[bgClass]"
  >
    <div class="status-icon-container rounded-circle" :class="[bgClass]">
      <feather-icon :icon="iconName" class="text-light" />
    </div>
    <div class="status-content">
      <h3 class="status-title font-weight-bold mb-1" :class="textColorClass">
        {{ title }}
      </h3>
      <p class="status-subtitle mb-0" :class="subtitleColorClass">
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      required: true,
      validator(value) {
        return ["success", "warning", "danger"].indexOf(value) !== -1;
      }
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    bgClass() {
      return `bg-${this.variant}`;
    },
    textColorClass() {
      // Enhanced contrast for title based on background
      switch (this.variant) {
        case "success":
          return "text-success-darken-2";
        case "warning":
          return "text-warning-darken-3";
        case "danger":
          return "text-danger-darken-2";
        default:
          return "text-dark";
      }
    },
    subtitleColorClass() {
      // Enhanced contrast for subtitle based on background
      switch (this.variant) {
        case "success":
          return "text-success-darken-3";
        case "warning":
          return "text-warning-darken-4";
        case "danger":
          return "text-danger-darken-3";
        default:
          return "text-muted";
      }
    },
    iconName() {
      switch (this.variant) {
        case "success":
          return "CheckCircleIcon";
        case "danger":
          return "XCircleIcon";
        case "warning":
          return "AlertCircleIcon";
        default:
          return null;
      }
    }
  }
};
</script>

<style lang="scss">
@import "~@core/scss/base/bootstrap-extended/include";

.status-hero {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  padding: 0;
  overflow: hidden;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  width: 100%;
  
  .status-icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 42px;
    height: 42px;
    margin: 0.75rem;
    padding: 0;
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
  
  .status-content {
    padding: 1rem;
    flex: 1;
    overflow: hidden;
  }
  
  .status-title {
    font-size: 1rem;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .status-subtitle {
    font-size: 0.8rem;
    font-weight: 500;
  }
  
  @include media-breakpoint-up(sm) {
    .status-icon-container {
      min-width: 56px;
      height: 56px;
      margin: 1rem;
      
      svg {
        width: 24px;
        height: 24px;
      }
    }
    
    .status-content {
      padding: 1.25rem;
    }
    
    .status-title {
      font-size: 1.15rem;
    }
    
    .status-subtitle {
      font-size: 0.9rem;
    }
  }
  
  @include media-breakpoint-up(md) {
    .status-icon-container {
      min-width: 64px;
      height: 64px;
      
      svg {
        width: 28px;
        height: 28px;
      }
    }
    
    .status-title {
      font-size: 1.25rem;
    }
    
    .status-subtitle {
      font-size: 0.95rem;
    }
  }
}
</style>
